import { Beaker, Landmark, BookOpen, Sparkles, Mic } from "lucide-react";

/**
 * Editorial ribbon — evergreen: the four ATFQ pillars from the media kit.
 * Deliberately quiet: light background, sentence case, slow marquee.
 */
export const AnnouncementChyron = () => {
  const items = [
    { Icon: Beaker, text: "Science — stripping speculation to focus on empirical evidence." },
    { Icon: Landmark, text: "Politics — dissecting institutional narratives and demanding accountability." },
    { Icon: BookOpen, text: "Philosophy — challenging ethical frameworks and societal structures." },
    { Icon: Sparkles, text: "Religion — analyzing belief systems with rigorous intellectual scrutiny." },
    { Icon: null, text: "Answer The F**king Question." },
  ];

  return (
    <a
      href="/#atfq"
      data-testid="announcement-chyron"
      className="fixed top-0 left-0 right-0 z-[60] bg-slate-100 text-slate-700 h-9 md:h-10 flex items-center overflow-hidden border-b border-slate-200 cursor-pointer group"
      role="banner"
      aria-label="ATFQ — the four pillars: Science, Politics, Philosophy, Religion"
    >
      <div className="flex items-center gap-2 px-4 md:px-6 h-full bg-[var(--navy-deep)] text-white shrink-0 z-10 relative">
        <Mic className="w-3.5 h-3.5 text-[var(--accent)]" />
        <span className="text-[11px] tracking-tight font-medium">
          ATFQ · Four Pillars
        </span>
      </div>

      <div className="flex-1 overflow-hidden relative">
        <div className="flex whitespace-nowrap chyron-track">
          {[0, 1].map((loop) => (
            <div
              key={loop}
              className="flex items-center gap-10 md:gap-16 px-8 md:px-12 shrink-0"
              aria-hidden={loop === 1}
            >
              {items.map(({ Icon, text }, i) => (
                <span
                  key={`${loop}-${i}`}
                  className="flex items-center gap-2 text-[12px] md:text-sm tracking-tight text-slate-700"
                >
                  {Icon && (
                    <Icon className="w-3.5 h-3.5 text-[var(--accent)] shrink-0" />
                  )}
                  {text}
                  <span className="text-slate-300 ml-6 md:ml-10">·</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </a>
  );
};

export default AnnouncementChyron;
